import { cubicPolyline } from "./bezier.js";
//#region src/utils/draw-relationship/loop.ts
var LOOP_STUB_RATIO = 1.2;
var LOOP_CURVATURE = 1.25;
function loopOffset(start, end) {
	return Math.max(Math.abs(end.x - start.x), Math.abs(end.y - start.y));
}
function loopStub(start, end) {
	return LOOP_STUB_RATIO * loopOffset(start, end);
}
function loopReach(start, end) {
	return 2.45 * loopOffset(start, end);
}
function loopPolyline(from, fromOutward, to, toOutward, offset) {
	const reach = LOOP_CURVATURE * offset;
	return cubicPolyline(from, {
		x: from.x + fromOutward.x * reach,
		y: from.y + fromOutward.y * reach
	}, {
		x: to.x + toOutward.x * reach,
		y: to.y + toOutward.y * reach
	}, to, 48);
}
//#endregion
export { LOOP_CURVATURE, LOOP_STUB_RATIO, loopOffset, loopPolyline, loopReach, loopStub };
